import { isPlatform } from '@ionic/react';
import { IStateCallback, State } from '@meraki-internal/state';
import { IPaymentTerm } from './RevenueCatModel';
import { IFreeTierLimits } from './IOfferMeta';
import { RevenueCatWebAdapter } from './RevenueCatWebAdapter';
import { RevenueCatNativeAdapter } from './RevenueCatNativeAdapter';

export interface IRevenueCatAdapter {
    subscribe: (callback: IStateCallback<any>) => () => void;
    init: () => Promise<void>;
    canMakeRealPayment: () => boolean;
    upgrade: (term: IPaymentTerm) => Promise<void>;
    restore: () => Promise<void>;
    getFreeTierLimits: () => IFreeTierLimits | undefined;
    hasUpgradeOffer: (term: IPaymentTerm) => boolean;
    isEligibleForTrial: () => boolean;
    getManagementLink: () => string | undefined;
    getDiagnostics: () => { [label: string]: any };
};

export class RevenueCatSDKModel extends State<Record<string, never>> {

    private adapter: IRevenueCatAdapter;

    static inject = () => [
        RevenueCatNativeAdapter,
        RevenueCatWebAdapter
    ];
    constructor(
        nativeAdapter: RevenueCatNativeAdapter,
        webAdapter: RevenueCatWebAdapter
    ) {
        super({});

        if (isPlatform('capacitor')) {
            this.adapter = nativeAdapter;
        } else {
            this.adapter = webAdapter;
        }

        this.adapter.subscribe(() => this.setState({}));
    }

    init = async () => await this.adapter.init();

    canMakeRealPayment = () => this.adapter.canMakeRealPayment();

    upgrade = async (term: IPaymentTerm) => await this.adapter.upgrade(term);

    restore = async () => await this.adapter.restore();

    getFreeTierLimits = () => this.adapter.getFreeTierLimits();

    hasUpgradeOffer = (term: IPaymentTerm) => this.adapter.hasUpgradeOffer(term);

    isEligibleForTrial = () => this.adapter.isEligibleForTrial();

    getManagementLink = () => this.adapter.getManagementLink();

    getDiagnostics = () => this.adapter.getDiagnostics();
}
